import { render, staticRenderFns } from "./StatisticByOperators.vue?vue&type=template&id=80d65fca&scoped=true&"
import script from "./StatisticByOperators.vue?vue&type=script&lang=js&"
export * from "./StatisticByOperators.vue?vue&type=script&lang=js&"
import style0 from "./StatisticByOperators.vue?vue&type=style&index=0&id=80d65fca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d65fca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDataTable,VProgressLinear})
